import pageTitle from 'ember-page-title/helpers/page-title';
import t from 'ember-intl/helpers/t';
import ConnectionStatus from 'frontend/components/connection-status';
import ApiVersionNotice from '../components/api-version-notice';
import UpdateNotification from 'frontend/components/update-notification';
import IliosHeader from 'frontend/components/ilios-header';
import { LinkTo } from '@ember/routing';
import IliosNavigation from 'frontend/components/ilios-navigation';
import ErrorDisplay from 'frontend/components/error-display';
import FlashMessages from 'frontend/components/flash-messages';
import set from 'ember-set-helper/helpers/set';

<template>
  {{pageTitle (t "general.ilios") separator=" " front=true}}
  <div id="ilios">
    <ConnectionStatus />
    <ApiVersionNotice />
    <UpdateNotification />
    <div class="application-wrapper{{if @controller.hasNavigation ' show-navigation'}}">
      {{#if @controller.useFullLayout}}
        <IliosHeader />
        <div class="ilios-logo">
          <LinkTo @route="dashboard" title={{t "general.dashboard"}}>
            <picture>
              <source
                srcset="/assets/images/ilios-logo.svg"
                media="(min-width: 400px)"
                alt={{t "general.logo"}}
              />
              <img src="/assets/images/sunburst.svg" alt={{t "general.logo"}} />
            </picture>

          </LinkTo>
        </div>
        {{#if @controller.session.isAuthenticated}}
          <IliosNavigation />
        {{/if}}
      {{/if}}
      <main id="main">
        {{#if @controller.applicationError}}
          <ErrorDisplay
            @error={{@controller.applicationError}}
            @clearError={{set @controller "applicationError" null}}
          />
        {{else}}
          {{outlet}}
        {{/if}}
      </main>
      {{#if @controller.useFullLayout}}
        <footer class="ilios-footer">
          <div class="version">
            {{@controller.iliosVersionTag}}
            {{@controller.apiVersionTag}}
            {{@controller.frontendVersionTag}}
          </div>
        </footer>
      {{/if}}
    </div>
    <FlashMessages />
  </div>
</template>
